export default __webpack_public_path__ + "static/media/ROM.32117a45.pdf";